import React, { Component } from 'react';
import api from './../../../utilites/api';
import ListCardapio from './../../../fragments/listCardapio'
import { setCar, setCarEmp, setCurrentTab, setProdSelc, delProdSelc } from './../../../redux/actions/';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import topo from './../../../assets/banner.png'
import logo from './../../../assets/logo.png'
// import { Container } from './styles';

class Home extends Component {
  state = {
    isLoading: false,
    colorHeader: "#991e25",
    cardapio: [],
    cardapioOr: [],
    padrao: '1',
    images: [
      topo
    ],
    consulta: '',
    produtosBusca: [],
    isSearching: false
  }

  async componentDidMount() {
    this.setState({ isLoading: true });

    try {
      const response = await api.post('ws/ListGrupoProd.php');
      console.log('Testeee ', response.data)
      if (response.status === 200) {
        this.setState({
          cardapio: response.data,
          cardapioOr: response.data
        });
      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);
      }

    } catch (error) {
      alert('Erro na comunicação com servidor!', 'Atenção', false);
    }

    this.setState({ isLoading: false });


  }

  form() {
    return (
      <div>
        {/* Banner da Logo */}
        <section style={{
          position: 'relative',
          width: '100%',
          height: 400,
          overflow: 'hidden',
          background: '#2c2c2c',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0',
          marginTop: 60
        }}>
          <img
            src={logo}
            alt="Casa da Pizza - Logo"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </section>

        {/* Container do Título e Barra de Pesquisa */}
        <section style={{
          position: 'relative',
          width: '100%',
          background: '#fff',
          padding: '20px',
          borderBottom: '1px solid #e0e0e0'
        }}>
          {/* Título da Seção */}
          <header style={{ 
            marginBottom: 20, 
            textAlign: 'center'
          }}>
            <h2 style={{ 
              fontSize: 32, 
              fontWeight: 800, 
              margin: 0, 
              color: '#991e25', 
              letterSpacing: '0.8px',
              textShadow: '0 2px 4px rgba(153, 30, 37, 0.1)',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}>
              Cardápio
            </h2>
          </header>

          {/* Barra de Pesquisa */}
          <div className="search-bar-desktop" style={{ 
            position: 'relative', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center' 
          }}>
            <div className="search-bar-inner-desktop" style={{ 
              width: '100%', 
              maxWidth: 450, 
              position: 'relative' 
            }}>
              <input
                type="text"
                placeholder="Buscar produtos..."
                value={this.state.consulta}
                onChange={this.handleInputBuscaChange}
                className="search-bar-input-desktop"
                style={{
                  padding: '12px 40px 12px 16px',
                  fontSize: 16,
                  width: '100%',
                  borderRadius: 25,
                  border: '1px solid #ccc',
                  outline: 'none',
                  background: '#fff',
                  color: '#333'
                }}
              />
              
              {/* Ícone de Pesquisa */}
              <span style={{ 
                position: 'absolute', 
                right: 16, 
                top: '50%', 
                transform: 'translateY(-50%)', 
                color: '#999', 
                fontSize: 18, 
                pointerEvents: 'none'
              }}>
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="8"/>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </span>
              
              {/* Dropdown de Resultados */}
              {this.state.consulta.length > 0 && (this.state.isSearching || this.state.produtosBusca.length > 0) && (
                <div className="dropdown-result" style={{
                  position: 'absolute',
                  top: 58,
                  left: 0,
                  width: '100%',
                  background: '#fff',
                  border: '2px solid #991e25',
                  borderRadius: '0 0 20px 20px',
                  boxShadow: '0 8px 32px rgba(153, 30, 37, 0.12)',
                  zIndex: 10,
                  maxHeight: 350,
                  overflowY: 'auto',
                  animation: 'fadeIn 0.3s ease',
                  padding: 0
                }}>
                  {this.state.isSearching && (
                    <div style={{ 
                      padding: 20, 
                      textAlign: 'center', 
                      color: '#991e25', 
                      fontWeight: 600, 
                      fontSize: 16 
                    }}>
                      Buscando produtos...
                    </div>
                  )}
                  {!this.state.isSearching && this.state.produtosBusca.length === 0 && (
                    <div style={{ 
                      padding: 20, 
                      textAlign: 'center', 
                      color: '#666', 
                      fontWeight: 400, 
                      fontSize: 15 
                    }}>
                      Nenhum produto encontrado
                    </div>
                  )}
                  {this.state.produtosBusca.map(prod => {
                    let imgUrl = prod.imagem;
                    // Usa a variável global de sistema para montar a URL da imagem
                    if (imgUrl && !imgUrl.startsWith('http')) {
                      try {
                        // Importa a classe apenas uma vez fora do map
                        if (!this._vglobais) {
                          const VariaveisGlobais = require('./../../../utilites/variaveisDoSistema').default;
                          this._vglobais = new VariaveisGlobais();
                        }
                        imgUrl = this._vglobais.getHostIMG + '/pod/' + imgUrl;
                      } catch (e) {
                        imgUrl = '/logo512.png'; // fallback
                      }
                    }

                    // Função para destacar o termo buscado
                    const highlight = (text) => {
                      const busca = this.state.consulta;
                      if (!busca) return text;
                      const regex = new RegExp(`(${busca.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                      return String(text).split(regex).map((part, i) =>
                        regex.test(part)
                          ? <span key={i} style={{ background: '#ffe066', color: '#991e25', fontWeight: 700 }}>{part}</span>
                          : part
                      );
                    };

                    return (
                      <div
                        key={prod.id}
                        style={{
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 14, 
                          padding: '14px 20px', 
                          borderBottom: '1px solid #f0f0f0', 
                          cursor: 'pointer', 
                          background: '#fff', 
                          transition: 'background-color 0.2s ease',
                        }}
                        onClick={() => {
                          const { setProdSelc, delProdSelc } = this.props;
                          delProdSelc();
                          setProdSelc(prod);
                          this.props.history.push({
                            pathname: '/Produto',
                            state: {
                              pp: prod
                            }
                          });
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                        onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                      >
                        <img 
                          src={imgUrl} 
                          alt={prod.nome} 
                          style={{ 
                            width: 50, 
                            height: 50, 
                            borderRadius: 10, 
                            objectFit: 'cover', 
                            background: '#f8f8f8', 
                            border: '1px solid #e0e0e0' 
                          }} 
                          onError={e => { 
                            e.target.onerror = null; 
                            e.target.src = '/logo512.png'; 
                          }} 
                        />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ 
                            fontWeight: 600, 
                            fontSize: 16, 
                            color: '#222', 
                            whiteSpace: 'normal', 
                            overflow: 'visible', 
                            textOverflow: 'unset', 
                            wordBreak: 'break-word',
                            marginBottom: 2
                          }}>
                            {highlight(prod.nome)}
                          </div>
                          <div style={{ 
                            fontSize: 13, 
                            color: '#991e25', 
                            fontWeight: 500, 
                            marginBottom: 2 
                          }}>
                            {highlight(prod.categoria || prod.grupo_nome || prod.grupo || '')}
                          </div>
                          <div style={{ 
                            fontSize: 12, 
                            color: '#666', 
                            whiteSpace: 'normal', 
                            overflow: 'visible', 
                            textOverflow: 'unset' 
                          }}>
                            {highlight(prod.obs || prod.descricao || '')}
                          </div>
                        </div>
                        <div style={{ 
                          fontWeight: 700, 
                          color: '#991e25', 
                          fontSize: 16, 
                          marginLeft: 10, 
                          minWidth: 70, 
                          textAlign: 'right' 
                        }}>
                          {this.mascaraValor(prod.preco)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Container Principal do Cardápio */}
        <main className="cardapio-container-responsive search-bar-desktop-wrapper" style={{ 
          width: '100%', 
          maxWidth: 500, 
          margin: '0 auto', 
          marginTop: 20,
          marginRight: 0, 
          background: '#fff', 
          padding: '20px', 
          position: 'relative', 
          boxSizing: 'border-box'
        }}>

          {/* Conteúdo do Cardápio */}
          {this.state.consulta.length === 0 && (
            <section style={{ 
              marginTop: 0, 
              width: '100%', 
              animation: 'fadeIn 0.6s ease-out' 
            }}>
              {this.state.isLoading ? this.formS() : this.List()}
            </section>
          )}
        </main>
      </div>
    );
  }

  buscaTimeout = null;

  handleInputBuscaChange = (e) => {
    const value = e.target.value;
    this.setState({ consulta: value });
    if (this.buscaTimeout) clearTimeout(this.buscaTimeout);
    if (value.trim().length === 0) {
      this.setState({ produtosBusca: [] });
      return;
    }
    this.buscaTimeout = setTimeout(() => {
      this.handleBuscaProdutos(value);
    }, 500); // 500ms debounce
  }

  handleBuscaProdutos = async (buscaStr) => {
    const busca = buscaStr !== undefined ? buscaStr : this.state.consulta;
    if (!busca) return;
    this.setState({ isSearching: true, produtosBusca: [] });
    try {
      // Usar GET com query string, pois o endpoint espera assim
      const response = await api.get(`ws/api_busca_produtos.php?busca=${encodeURIComponent(busca)}`);
      if (response.status === 200 && Array.isArray(response.data)) {
        this.setState({ produtosBusca: response.data });
      } else {
        this.setState({ produtosBusca: [] });
      }
    } catch (error) {
      this.setState({ produtosBusca: [] });
    }
    this.setState({ isSearching: false });
  }

  getValorCarrinho() {
    let vl = 0.00;
    this.props.carr.carrinho.forEach(i => {
      vl += parseFloat(i.preco) || 0;
    });
    return this.mascaraValor(vl.toFixed(2));
  }

  mascaraValor(valor) {
    // Garante que o valor é numérico e formata como moeda brasileira
    let num = Number(valor);
    if (isNaN(num)) num = 0;
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // Ajustar o grid dos cards do cardápio para desktop
  List() {
    return (
      <div style={{ marginTop: 0, width: '100%', display: this.state.padrao === '1' ? 'flex' : 'column', flexWrap: this.state.padrao === '1' ? 'wrap' : 'nowrap', justifyContent: 'space-between', marginBottom: 120, gap: '10px' }}>
        {this.state.cardapio.map(i => (
          <ListCardapio Imagem={i.imagem} Nome={i.nome} padrao={this.state.padrao} acao={() => {
            this.props.history.push({
              pathname: '/Cardapio',
              state: {
                grupo: i.id,
                nome: i.nome
              }
            })
          }} />
        ))}
      </div>
    )
  }

  formS() {
    return (
      <div>
        <Skeleton variant="rect" height={50} style={{marginBottom: 15}}/>
        <Skeleton variant="rect" height={50} style={{marginBottom: 15}} />
        <Skeleton variant="rect" height={50} style={{marginBottom: 15}} />
        <Skeleton variant="rect" height={50}  style={{marginBottom: 15}}/>
        <Skeleton variant="rect" height={50} style={{marginBottom: 15}} />
      </div>

    );
  }

  header() {
    return (
      <header style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 60,
        backgroundColor: this.state.colorHeader,
        zIndex: 1002,
        display: "flex", 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '0 20px',
        boxShadow: '0 2px 8px rgba(153, 30, 37, 0.2)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h1 style={{ 
            fontSize: 28, 
            fontWeight: 700, 
            margin: 0, 
            color: 'white',
            letterSpacing: '0.5px'
          }}>
            Início
          </h1>
        </div>
        
        <button
          type="button"
          style={{ 
            background: 'none', 
            border: 'none', 
            display: "flex", 
            alignItems: 'center', 
            cursor: 'pointer', 
            padding: '8px 12px',
            borderRadius: '8px',
            transition: 'background-color 0.2s ease',
            color: '#fff'
          }}
          onClick={() => {
            const { setCurrentTab } = this.props;
            setCurrentTab(1)
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          aria-label="Abrir carrinho"
        >
          <ShoppingCartIcon style={{ fontSize: 24, marginRight: 8 }} />
          <span style={{ fontSize: 18, fontWeight: 600 }}>{this.getValorCarrinho()}</span>
        </button>
      </header>
    );
  }

  // ...existing code...

  handlePresquisa = async () => {
    var temp = this.state.cardapioOr;

    let result = temp.filter((item) => { return item.nome.match(this.state.consulta) });
    this.setState({ cardapio: result });
  }

  render() {
    // Animação fadeIn global
    return (
      <div style={{ minHeight: 'calc(100vh - 75px)', background: '#ffffff', padding: 0, margin: 0, transition: 'background 0.5s', paddingBottom: '75px' }}>
        <style>{`
          /* DESKTOP: Estica a barra de pesquisa e tudo que envolve ela */
          @media (min-width: 900px) {
            .search-bar-desktop-wrapper {
              max-width: 100vw !important;
              width: 100vw !important;
              margin: 0 !important;
              border-radius: 0 !important;
              box-shadow: none !important;
              padding: 32px 0 32px 0 !important;
              margin-top: 20px !important;
            }
            .search-bar-desktop {
              width: 100vw !important;
              max-width: 100vw !important;
              justify-content: center !important;
              align-items: flex-end !important;
              margin-bottom: 36px !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
            .search-bar-inner-desktop {
              width: 60vw !important;
              max-width: 900px !important;
              min-width: 400px !important;
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
            .search-bar-input-desktop {
              font-size: 22px !important;
              padding: 20px 60px 20px 28px !important;
              border-radius: 32px !important;
              border-width: 2.5px !important;
              box-shadow: 0 4px 24px #991e2511 !important;
              min-height: 60px !important;
            }
            .dropdown-result {
              max-width: 900px !important;
              left: 0 !important;
              width: 60vw !important;
              border-radius: 0 0 20px 20px !important;
              font-size: 18px !important;
            }
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .cardapio-container-responsive {
            box-sizing: border-box;
          }
          /* DESKTOP: Preencher toda a tela */
          @media (min-width: 900px) {
            .cardapio-container-responsive {
              max-width: 100vw !important;
              width: 100vw !important;
              margin: 0 !important;
              border-radius: 0 !important;
              box-shadow: none !important;
              padding: 32px 60px 32px 60px !important; /* Maior padding para desktop */
              min-height: calc(100vh - 75px);
              padding-bottom: 75px;
            }
          }
          /* TABLET/MOBILE: Layout compacto centralizado, sem borda arredondada */
          @media (max-width: 899px) {
            .cardapio-container-responsive {
              max-width: 98vw !important;
              padding: 15px 30px !important; /* Padding maior para tablets */
              border-radius: 0 !important;
              margin: 0 auto !important;
              margin-top: 20px !important;
              min-height: calc(100vh - 75px);
              padding-bottom: 75px;
              box-shadow: 0 2px 16px #0001 !important;
            }
            .cardapio-container-responsive input[type="text"] {
              font-size: 16px !important;
              padding: 12px 38px 12px 12px !important;
            }
          }
          @media (max-width: 480px) {
            .cardapio-container-responsive {
              max-width: 100vw !important;
              padding: 10px 25px !important; /* Padding maior para mobile */
              border-radius: 0 !important;
              margin-top: 20px !important;
            }
            .cardapio-container-responsive input[type="text"] {
              font-size: 15px !important;
              padding: 10px 32px 10px 10px !important;
            }
            .cardapio-container-responsive .dropdown-result {
              left: 0 !important;
              width: 100vw !important;
              min-width: 0 !important;
              border-radius: 0 0 12px 12px !important;
            }
          }
        `}</style>
        {/* Cabeçario */}
        {this.header()}
        {/* Corpo */}
        {this.form()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  carr: state.CarrinhoReducer
});


// Inclui as actions de produto para uso na busca
const mapDispatchToProps = dispatch =>
  bindActionCreators({ setCar, setCarEmp, setCurrentTab, setProdSelc, delProdSelc }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
